import { render, staticRenderFns } from "./messageHandle.vue?vue&type=template&id=1df22fc2&scoped=true"
import script from "./messageHandle.vue?vue&type=script&lang=js"
export * from "./messageHandle.vue?vue&type=script&lang=js"
import style0 from "./messageHandle.vue?vue&type=style&index=0&id=1df22fc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df22fc2",
  null
  
)

export default component.exports